

exports.__esModule = true;
exports.$SidebarAddCardRoute = undefined;

require('./directive');

require('components/xo-wallet-components/src/add-card/route');

var _squid = require('squid');

var $SidebarAddCardRoute = exports.$SidebarAddCardRoute = _squid.$ComponentRoute.extend('$SidebarAddCardRoute', {

    path: 'sidebarAddCard',
    directive: 'xo-sidebar-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion'
        }
    }]
});

angular.value("$SidebarAddCardRoute", $SidebarAddCardRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-card/route.js
 ** module id = 330
 ** module chunks = 1
 **/